import { render } from "./Clasificacion.vue?vue&type=template&id=67cba83a"
import script from "./Clasificacion.vue?vue&type=script&lang=js"
export * from "./Clasificacion.vue?vue&type=script&lang=js"

import "./Clasificacion.vue?vue&type=style&index=0&id=67cba83a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__